<template>
  <div class="mb-3">
    <v-layout row wrap>
      <v-flex shrink>
        <v-autocomplete
          v-if="(paymentType === 'card' || $route.name === 'ChargeCard' || $route.name === 'StandaloneRefund') && terminalsCardCanCharge.length > 1"
          label="Terminal"
          v-model="terminal"
          :items="cardTerminalList"
          item-text="name"
          item-value="terminal_id"
          box
          class="paymentTerminal"
          :error-messages="terminal.terminal_id ? '' : 'Required'"
          hide-details
          required
          :rules="terminalRules"
        >
          <template slot="item" slot-scope="props">
            <v-layout columns wrap>
              <v-flex>
                <v-flex xs12>
                  <div>{{ props.item.name }}</div>
                </v-flex>
                <v-flex xs12 v-if="showDetails">
                  <div class="caption">{{ props.item.code }}</div>
                </v-flex>
              </v-flex>
              <v-flex v-if="hasPermission('superuser') && props.item.processor_id">
                <div class="subtitle text-xs-right" v-if="props.item.processor_id === 3">
                  <v-chip small class="ml-2">FAPS</v-chip>
                </div>
                <div class="subtitle text-xs-right" v-if="props.item.processor_id === 5">
                  <v-chip small class="ml-2">TRX</v-chip>
                </div>
                <div class="subtitle text-xs-right" v-if="props.item.processor_id === 6">
                  <v-chip small class="ml-2">PNX</v-chip>
                </div>
              </v-flex>
            </v-layout>
          </template>
        </v-autocomplete>

        <v-autocomplete
          v-if="(paymentType === 'ach' || $route.name === 'ChargeACH') && terminalsACHCanCharge.length > 1"
          label="Terminal"
          v-model="terminal"
          :items="achTerminalList"
          item-text="name"
          item-value="terminal_id"
          box
          class="paymentTerminal"
          :error-messages="terminal.terminal_id ? '' : 'Required'"
          hide-details
          required
          :rules="terminalRules"
        >
          <template slot="item" slot-scope="props">
            <v-layout columns wrap>
              <v-flex>
                <v-flex xs12>
                  <div>{{ props.item.name }}</div>
                </v-flex>
                <v-flex xs12 v-if="showDetails">
                  <div class="caption">{{ props.item.code }}</div>
                </v-flex>
              </v-flex>
              <v-flex v-if="hasPermission('superuser') && props.item.processor_id">
                <div class="subtitle text-xs-right" v-if="props.item.processor_id === 3">
                  <v-chip small class="ml-2">FAPS</v-chip>
                </div>
                <div class="subtitle text-xs-right" v-if="props.item.processor_id === 4">
                  <v-chip small class="ml-2">META</v-chip>
                </div>
                <div class="subtitle text-xs-right" v-if="props.item.processor_id === 5">
                  <v-chip small class="ml-2">TRX</v-chip>
                </div>
                <div class="subtitle text-xs-right" v-if="props.item.processor_id === 6">
                  <v-chip small class="ml-2">PNX</v-chip>
                </div>
              </v-flex>
            </v-layout>
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [APIMixin, AuthMixin, DisplayMixin, StoreMixin],
  props: {
    value: Object,
    paymentType: {
      type: String,
      default: '' // @TODO Default to card once used universally?
    },
    processorId: [Number, Array],
    accountId: Number,
    showDetails: Boolean
  },
  data () {
    return {
      terminalRules: [
        (v) => !!v || 'Terminal is required'
      ]
    }
  },
  computed: {
    terminal: {
      get () {
        return this.value
      },

      set (value) {
        let terminal = null

        if (value === 0) {
          this.$store.commit('SELECT_ACCOUNT', 0)
          this.$store.commit('SELECT_TERMINAL', 0)
          this.$emit('input', {name: ''})
        } else {
          if (this.paymentType === 'card' || this.$route.name === 'ChargeCard' || this.$route.name === 'StandaloneRefund') {
            terminal = this.terminalsCardCanCharge.find(terminal => terminal.terminal_id == value)
          } else if (this.paymentType === 'ach' || this.$route.name === 'ChargeACH') {
            terminal = this.terminalsACHCanCharge.find(terminal => terminal.terminal_id == value)
          }

          if (terminal) {
            this.$store.commit('SELECT_ACCOUNT', terminal.account_id)
            this.$store.commit('SELECT_TERMINAL', terminal.terminal_id)
            this.$emit('input', terminal)
          }
        }
      }
    },

    terminalList: function () {
      let terminals = [
        {terminal_id: 0, name: '- Please Select -'}
      ]

      if (this.paymentType === 'ach') {
        if (this.accountId) {
          return terminals.concat(this.terminalsACHCanCharge.filter(terminal => terminal.account_id === this.accountId))
        } else if (this.processorId) {
          return terminals.concat(this.terminalsACHCanCharge.filter(terminal =>
            Array.isArray(this.processorId)
              ? this.processorId.includes(terminal.processor_id)
              : terminal.processor_id === this.processorId
          ))
        } else {
          return terminals.concat(this.terminalsACHCanCharge)
        }
      } else {
        if (this.accountId) {
          return terminals.concat(this.terminalsCardCanCharge.filter(terminal => terminal.account_id === this.accountId))
        } else if (this.processorId) {
          return terminals.concat(this.terminalsCardCanCharge.filter(terminal =>
            Array.isArray(this.processorId)
              ? this.processorId.includes(terminal.processor_id)
              : terminal.processor_id === this.processorId
          ))
        } else {
          return terminals.concat(this.terminalsCardCanCharge)
        }
      }
    },

    cardTerminalList: function () {
      let terminals = [
        {terminal_id: 0, name: '- Please Select -'}
      ]

      if (this.accountId) {
        return terminals.concat(this.terminalsCardCanCharge.filter(terminal => terminal.account_id === this.accountId))
      } else if (this.processorId) {
        return terminals.concat(this.terminalsCardCanCharge.filter(terminal =>
          Array.isArray(this.processorId)
            ? this.processorId.includes(terminal.processor_id)
            : terminal.processor_id === this.processorId
        ))
      } else {
        return terminals.concat(this.terminalsCardCanCharge)
      }
    },

    achTerminalList: function () {
      let terminals = [
        {terminal_id: 0, name: '- Please Select -'}
      ]
      if (this.accountId) {
        return terminals.concat(this.terminalsACHCanCharge.filter(terminal => terminal.account_id === this.accountId))
      } else if (this.processorId) {
        return terminals.concat(this.terminalsACHCanCharge.filter(terminal =>
          Array.isArray(this.processorId)
            ? this.processorId.includes(terminal.processor_id)
            : terminal.processor_id === this.processorId
        ))
      } else {
        return terminals.concat(this.terminalsACHCanCharge)
      }
    }
  },

  methods: {
    reset (terminalId) {
      if (terminalId) {
        this.terminal = terminalId
      } else if ((this.paymentType === 'card' || this.$route.name === 'ChargeCard') && this.terminalsCardCanCharge && this.terminalsCardCanCharge.length) {
        if (this.myProfile.custom.hasOwnProperty('default_card_terminal_id') && this.terminalsCardCanCharge.length > 1) {
          this.terminal = this.myProfile.custom.default_card_terminal_id
        } else {
          this.terminal = this.terminalsCardCanCharge[0].terminal_id
        }
      } else if ((this.paymentType === 'ach' || this.$route.name === 'ChargeACH') && this.terminalsACHCanCharge && this.terminalsACHCanCharge.length) {
        if (this.myProfile.custom.hasOwnProperty('default_ach_terminal_id') && this.terminalsACHCanCharge.length > 1) {
          this.terminal = this.myProfile.custom.default_ach_terminal_id
        } else {
          this.terminal = this.terminalsACHCanCharge[0].terminal_id
        }
      }
    }
  }
}
</script>

<style lang="less">
  .paymentTerminal .v-select__selection--disabled {
    color: black !important;
    font-weight: 900;
  }
</style>



// WEBPACK FOOTER //
// src/components/terminal/components/TerminalSelect.vue